import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "carspa_admin_token";

export const adminApi = axios.create({ baseURL: API, withCredentials: true });
adminApi.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const formatApiError = (detail, fallback = "Něco se pokazilo. Zkuste to znovu.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
};

export const login = async (username, password) => {
  const { data } = await adminApi.post("/auth/login", { username, password });
  sessionStorage.setItem(TOKEN_KEY, data.token);
  return data.user;
};

export const logout = async () => {
  sessionStorage.removeItem(TOKEN_KEY);
  try {
    await adminApi.post("/auth/logout");
  } catch {
    /* ignore */
  }
};

export const me = async () => (await adminApi.get("/auth/me")).data;
export const fetchReservations = async () => (await adminApi.get("/reservations")).data;
export const fetchStats = async () => (await adminApi.get("/admin/stats")).data;
export const setStatus = async (id, status, paid_amount) => (await adminApi.patch(`/reservations/${id}/status`, { status, paid_amount })).data;
export const sendTestEmail = async () => (await adminApi.post("/admin/test-email")).data;
export const fetchCampaign = async (spots) => (await adminApi.get("/admin/campaign", { params: { spots } })).data;
export const fetchAvailability = async () => (await adminApi.get("/availability")).data;
export const setCapacity = async (capacity) => (await adminApi.put("/admin/capacity", { capacity })).data;
export const sendCampaignToOwner = async (spots) => (await adminApi.post("/admin/campaign/send-to-owner", null, { params: { spots } })).data;
